import {createSlice} from "@reduxjs/toolkit";

interface IInitialState {
  message: string;
  updateUserEmailStatus: "idle" | "pending" | "resolved" | "rejected";
  updateUserPasswordStatus: "idle" | "pending" | "resolved" | "rejected";
}

const initialState: IInitialState = {
  message: "",
  updateUserEmailStatus: "idle",
  updateUserPasswordStatus: "idle",
};

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {
    userSettingsLogoutReset: (state) => initialState,
  },
});

export const {userSettingsLogoutReset} = settingsSlice.actions;

export default settingsSlice.reducer;
